module.exports = __webpack_public_path__ + "static/media/account_white.217260fb.svg";